import PropTypes from 'prop-types'
import React from 'react'
import Header from 'components/Header'

const FaqLayoutHeader = ({ showSidebarToggle = false }) => (
  <Header
    alwaysShowActions
    hasBalance={false}
    showSidebarToggle={showSidebarToggle}
  />
)

FaqLayoutHeader.propTypes = {
  showSidebarToggle: PropTypes.bool,
}

export default FaqLayoutHeader
